import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { forkJoin, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { saveAs } from 'file-saver';

@Injectable({
  providedIn: 'root',
})
export class WorkShiftsService {
  public moment = require('moment');
  constructor(private http: HttpClient) {}

  getCellTypes() {
    return this.http.get(`/admin/cell_types/`);
  }

  getScheduleTypes() {
    return this.http.get(`/admin/schedule_types/`);
  }

  getWorkShiftsSectors(id, params) {
    return this.http.get(`/admin/users/${id}/sectors/`, { params: params });
  }

  getMetaDataProductionCalendar(params) {
    return this.http.get(`/admin/production_calendar/`, { params: params });
  }

  downloadUsers(params): Observable<HttpResponse<Blob>> {
    return this.http
      .get(`/admin/schedules/download`, {
        params: params,
        responseType: 'blob',
        observe: 'response',
      })
      .pipe(
        tap((response) => {
          const contentDisposition = response.headers.get('content-disposition');
          const filename = contentDisposition.match(/filename="(.+)?"/)[1];
          saveAs(response.body, filename);
        })
      );
  }

  getUsers(params) {
    return this.http.get(`/admin/schedules/`, { params: params });
  }

  getPlotsForWorkShifts(params): Observable<any> {
    return this.http.get(`/admin/sector_numbers/`, { params });
  }

  getFilterUnionData(id, params) {
    const cellTypes = this.getCellTypes();
    const scheduleTypes = this.getScheduleTypes();
    const sectors = this.getWorkShiftsSectors(id, params);
    const plots = this.getPlotsForWorkShifts(params);

    return forkJoin([cellTypes, scheduleTypes, sectors, plots]);
  }

  saveOrEditCells(data) {
    return this.http.post(`/admin/schedules/`, data);
  }

  fixedPlannedSchedule(data) {
    return this.http.post(`/admin/schedules/fix_planned_schedule/`, data);
  }

  retrieveSchedule(schedule) {
    // Если нет расписания вообще, возвращаем null
    if (!schedule) {
      return null;
    }

    // Если есть тип ячейки, всегда возвращаем расписание
    // Это исправляет проблему с пустыми ячейками после редактирования
    if (schedule.cell_type) {
      return schedule;
    }

    // Возвращаем расписание для всех остальных случаев
    return schedule;
  }

  updateWorkingShift(workingShift, cell) {
    const indexOfWorkday = workingShift.findIndex((shift) => this.moment(shift.workday).isSame(cell.workday));
    const result = workingShift.slice();
    result[indexOfWorkday] = cell;
    return result;
  }

  formatWorkingShift(workShifts) {
    workShifts.forEach((workShift, index) => {
      const hasSchedule = workShift.schedule;
      const isEndDateAfterWorkday = workShift.schedule && this.moment(workShift.schedule.int_end, 'YYYY-MM-DD').isAfter(this.moment(workShift.workday, 'YYYY-MM-DD'), 'day');
      const nextWorkDay = workShifts[index + 1];

      if (!nextWorkDay) {
        return;
      }

      const isNextScheduleEmpty = nextWorkDay && !nextWorkDay.schedule;

      if (hasSchedule && isEndDateAfterWorkday && isNextScheduleEmpty) {
        workShifts[index + 1] = {
          ...nextWorkDay,
          schedule: {
            int_begin: null,
            int_end: null,
            commentary: '',
            int_delta: 0,
            sector: null,
            sector_id: null,
            cell_type: {
              ct_id: 1,
            },
          },
        };
      }

      if (!nextWorkDay.ws_id && !isNextScheduleEmpty && !isEndDateAfterWorkday) {
        workShifts[index + 1] = {
          ...nextWorkDay,
          schedule: null,
        };
      }
    });

    return workShifts;
  }
}
